export const initHeaderState = () => {
  const header = document.querySelector('.site-header');

  if (!header) {
    return;
  }

  const toggleScrolled = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  toggleScrolled();
  window.addEventListener('scroll', toggleScrolled, { passive: true });
};